import {Component} from '@angular/core';
import Quill from 'quill';

/**
 * Class for the AbstractQuillToolbarButtonComponent
 * @class
 * @abstract
 */
@Component({
  selector: 'advtech-abstract-quill-toolbar-button',
  templateUrl: './abstract-quill-toolbar-button.component.html',
})
export abstract class AbstractQuillToolbarButtonComponent {
  /**
   * The quill instance
   * @type {any}
   * @private
   */
  private _quill: Quill;

  /**
   * Initializes the button
   * @param {any | Quill} quill
   * @returns {void}
   */
  init(quill: Quill) {
    this.quill = quill;
  }

  /**
   * Getter for the quill property
   * @returns {any}
   */
  get quill(): Quill {
    return this._quill;
  }

  /**
   * Setter for the quill property
   * @param {any} value
   */
  set quill(value: Quill) {
    this._quill = value;
  }

  /**
   * Handles clicking of the button
   * @abstract
   * @returns {any}
   */
  abstract hClick(): any;

}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/abstract-quill-toolbar-button/abstract-quill-toolbar-button.component.ts